// extracted by mini-css-extract-plugin
module.exports = {"iconsBox":"ConvertToLARModal_iconsBox__3yg60","blueIconCircle":"ConvertToLARModal_blueIconCircle__EsVFe","greenIconCircle":"ConvertToLARModal_greenIconCircle__D32Gb"};